import React, { useEffect, useState } from 'react';
import _ from 'lodash';
export const StepperInput = ({ name, options, value, error, onblur, onchange }) => {
    const [stepperValue, setStepperValue] = useState(value);
    useEffect(() => setStepperValue(value), [value]);
    const onChange = (newValue) => {
        if (onchange) {
            onchange(undefined, newValue);
        }
        else {
            setStepperValue(newValue);
        }
    };
    const optionCount = options ? options.length : 0;
    const isSingleOption = optionCount === 1;
    return (React.createElement("div", { className: `stepper ${isSingleOption ? 'stepper-single-option' : ''}` },
        React.createElement("div", { className: `btn-group btn-block btn-darken ${error ? 'invalid' : ''}` }, _.map(options || [], (o, i) => (React.createElement("button", { key: `btn-${name}-${i}`, id: `btn-${name}-${i}`, className: `btn ${o.value === stepperValue ? 'btn-dark btn-active' : 'btn-white'}`, onClick: () => onChange(o.value), onBlur: onblur, type: "button", disabled: o.disabled }, o.label || o.value))))));
};
//# sourceMappingURL=Stepper.js.map